import React from 'react'

function ScriptCont() {
  return (
    <section className='script__cont'>
      <div className="container">
        <div className="script__inner">
          <article className='script'>
            <figure className='img'>
              <img src="/img/script01.png" alt="이미지1" />
            </figure>
            <div className="btn">
              <a href="/" className='active'>1</a>
              <a href="/">2</a>
              <a href="/">3</a>
              <a href="/">4</a>
              <a href="/">5</a>
              <a href="/">6</a>
              <a href="/">7</a>
              <a href="/">8</a>
              <a href="/">9</a>
              <a href="/">10</a>
            </div>
              <h4>animationRequestFrame</h4>
            <div className="text">
              <p>레이아웃은 사이트를 만드는데 가장 기본적이 요소입니다. 레이아웃만 제대로 만들 수 있다면 사이트의 제작에 50%는 끝나다고 보셔도 됩니다. 그만큼 레이아웃 제작은 상당히 중요합니다. 사이트의 제작에 50%는 끝나다고 보셔도 됩니다. 그만큼 레이아웃 제작은 상당히 중요합니다.</p>
              <p>레이아웃은 사이트를 만드는데 가장 기본적이 요소입니다. 레이아웃만 제대로 만들 수 있다면 사이트의 제작에 50%는 끝나다고 보셔도 됩니다. 그만큼 레이아웃 제작은 상당히 중요합니다. 사이트의 제작에 50%는 끝나다고 보셔도 됩니다. 그만큼 레이아웃 제작은 상당히 중요합니다.</p>
            </div>
          </article>
        </div>
      </div>
    </section>
    )
}

export default ScriptCont